import { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { getReviews, IReview } from "../api/getReviews";
import CardReviewProfessional from "../components/cards/CardReviewProfessional";
import PageWrapper from "../components/common/PageWrapper";
import CardReviewLoader from "../components/loaders/CardReviewLoader";
import { formatDate } from "../utils/date-util/dateUtils";

const ReviewsWrapper = styled.div`
	display: flex;
	flex-flow: column;
	height: 100vh;
`;

const NoReviews = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
	align-content: normal;
	height: 100vh;
	color: #6f7590;
	font-family: "Livvic";
	font-style: normal;
	font-weight: 400;
	font-size: 15px;
	line-height: 150%;
	padding: 0 20px;
`;

/**
 * ### Reviews do profissional
 * Lista todas as analises do profissional
 */
const ProfessionalReviewsScreen: FC = () => {
	const { professionalId } = useParams<{ professionalId: string }>();

	const [reviews, setReviews] = useState<IReview[]>([]);
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		if (professionalId) carregaDados(professionalId);
	}, [professionalId]);

	const carregaDados = (idProfessional: string) => {
		setLoading(true);
		getReviews(idProfessional).then(response => {
			setLoading(false);
			setReviews(response.data);
		});
	};

	const renderReviews = () => {
		return (
			<PageWrapper>
				{reviews.length > 0 ? (
					reviews.map(review => (
						<CardReviewProfessional
							key={review._id}
							name={review.pessoa || "Anônimo"}
							grade={review.nota}
							comment={review.descricao}
							date={formatDate("dd/MM/yyyy", review.criado)}
						/>
					))
				) : (
					<NoReviews>Este profissional não possui avaliações até o momento..</NoReviews>
				)}
			</PageWrapper>
		);
	};

	return <ReviewsWrapper>{!loading ? renderReviews() : <CardReviewLoader />}</ReviewsWrapper>;
};

export default ProfessionalReviewsScreen;
